import { render, staticRenderFns } from "./EducationModules.vue?vue&type=template&id=0e684656&"
import script from "./EducationModules.vue?vue&type=script&lang=ts&"
export * from "./EducationModules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports